import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsAddedToSaved } from "@/redux/savedpreference/savedPreferenceSlice";
import { onCfdSavePress, onCfdUnsavePress } from "@/api/cfd";
import "./../CashForDeed.css";
import FavHeartSvg from "../../../../../public/assets/svg/property-card/FavHeartSvg";
import NotFavHeartSvg from "../../../../../public/assets/svg/property-card/NotFavHeartSvg";
import save from "../../../../../public/assets/images/pdp/save.svg";
import saved from "../../../../../public/assets/images/pdp/saved.svg";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";

const FavoriteButton = ({
  item,
  isPropertySaved,
  setIsPropertySaved,
  setShowModal,
  activeTab,
}) => {
  const propertyId =
    activeTab === "saved"
      ? item?.propertyDetails?.propertyId
      : item?.propertyId;

  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const dispatch = useDispatch();

  const onSave = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (userEmailId) {
      if (isPropertySaved) {
        trackButtonClick({
          eventName: "favourite_property_unsave_click",
          eventCategory: "CFD",
          eventSource: "cfd",
          eventLabel: `Property Id: ${propertyId}`,
        });

        setIsPropertySaved(false);
        const response = await onCfdUnsavePress({ propertyId: propertyId });
        if (response == "success") {
          dispatch(setIsAddedToSaved(true));
          trackApiCall({
            eventName: "favourite_property_unsaved",
            eventCategory: "CFD",
            eventSource: "cfd",
            eventLabel: `Property Id: ${propertyId} | propertyStatus: ${item.propertyStatus}`,
          });
        }
      } else {
        trackButtonClick({
          eventName: "favourite_property_save_click",
          eventCategory: "CFD",
          eventSource: "cfd",
          eventLabel: `Property Id: ${propertyId}`,
        });
        setIsPropertySaved(true);
        const response = await onCfdSavePress({ propertyId: propertyId });
        if (response == "success") {
          dispatch(setIsAddedToSaved(false));
          trackApiCall({
            eventName: "favourite_property_saved",
            eventCategory: "CFD",
            eventSource: "cfd",
            eventLabel: `Property Id: ${propertyId} | propertyStatus: ${item.propertyStatus}`,
          });
        }
      }
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="cfd-favorite-btn-container">
      <button className={`cfd-favorite-btn`} onClick={onSave}>
        {/* {isPropertySaved ? <FavHeartSvg /> : <NotFavHeartSvg />} */}
        <img
          src={isPropertySaved ? saved : save}
          className="cfd-fav-toggle-img"
          alt=""
          aria-hidden="true"
        />
      </button>
    </div>
  );
};

export default memo(FavoriteButton);
